import { getRequest, putRequest, postRequest, deleteRequest } from "./request";
export const sampleApi = function () {};
sampleApi.prototype = {
  /* 获取看样详情 */
  async getDecideInfoMobile(info) {
    let res = await postRequest(
      `/sobuyLookProof/getDecideInfoMobile?proofId=${info.proofId}&userId=${info.userId}`
    );
    return res.data.decideOutMobileVO;
  },
  /* 获取标记 */
  async getPointListByUserId(info) {
    let res = await getRequest(
      `/sobuyLookProof/getPointListByUserId?proofId=${info.proofId}&userId=${info.userId}`
    );
    return res.data.myPointList;
  },
  /* 获取颜色 */
  async getLookProofColors(info) {
    let res = await getRequest(`/field/getLookProofColors`);
    return res.data.LookProofColors;
  },
  /* 发布看样意见 */
  async addLookIdea(info) {
    let res = await postRequest(`/sobuyLookProof/addLookIdea`, info);
    return res;
  },
  /* 获取系列 */
  async getList(info) {
    let res = await getRequest(`/proType/getList`);
    return res;
  },
  /* 获取淘汰理由 */
  async getDecideOutReason() {
    let res = await getRequest(`/field/getDecideOutReason`);
    return res.data.proofOutReasons;
  },
  /* 提交决策 */
  async decideSubmit(info) {
    let res = await postRequest(`/sobuyLookProof/decideSubmit`, info);
    return res;
  },
  async getStashList() {
    let res = await getRequest("/OrdCountry/getAllCountrys");
    return res.data.outCountrys;
  },
  async getOrderList(proofId) {
    let res = await getRequest(
      `sobuyLookProof/getDecideByLookOrderList//${proofId}`
    );
    return res.data.orderListVO.orderList;
  },
  /* 拒绝看样下单 */
  async subAdvice(info) {
    let res = await postRequest("/sobuyLookProof/addLookIdea", info);
    return res;
  },
  /* 获取数据权限中的业务员 */
  async getSalesmanList(info) {
    const res = await getRequest("/sobuyLookProof/getDataGroupUsers", info);
    return res.data.dataGroup;
  },
  async getOtherInfo(proofId) {
    const res = await getRequest(`/sobuyLookProof/getOtherSupInfo/${proofId}`);
    return res.data;
  }
};
